module.exports = __webpack_public_path__ + "img/login.914a87f1.png";